export default __webpack_public_path__ + "static/media/blog@2x.e7f5f55f.webp";